import React, { FC, useCallback } from "react";

import { Guide, GuideUserStatus } from "@mapmycustomers/shared/types/entity";
import { LoadingSpinner } from "@mapmycustomers/ui";

import NoRows from "../../NoRows";

import GuideCard from "./GuideCard";
import styles from "./Guides.module.scss";

export interface GuidesProps {
  guides: Guide[];
  guidesStatusMap: Record<Guide["id"], GuideUserStatus[]>;
  loading?: boolean;
  onResetFilters?: () => void;
  onSelectionChange?: (selectedGuideIds: Guide["id"][]) => void;
  selectedGuideIds: Guide["id"][];
}

const Guides: FC<GuidesProps> = ({
  guides,
  guidesStatusMap,
  loading,
  onResetFilters,
  onSelectionChange,
  selectedGuideIds,
}) => {
  const handleSelectionChange = useCallback(
    (guideId: Guide["id"], checked: boolean) => {
      if (checked) {
        onSelectionChange?.([...selectedGuideIds, guideId]);
      } else {
        onSelectionChange?.(selectedGuideIds.filter((id) => id !== guideId));
      }
    },
    [selectedGuideIds, onSelectionChange]
  );

  return loading ? (
    <LoadingSpinner global />
  ) : guides.length ? (
    <div className={styles.container}>
      {guides.map((guide) => (
        <GuideCard
          guide={guide}
          guideStatus={guidesStatusMap[guide.id]}
          key={guide.id}
          onToggle={handleSelectionChange}
          selected={selectedGuideIds.includes(guide.id)}
        />
      ))}
    </div>
  ) : (
    <NoRows onResetFilters={onResetFilters} />
  );
};

export default Guides;
